<template>
  <section class="section">
    <div class="is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">Configurações</h1>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item"></div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <b-tabs type="is-toggle">
          <b-tab-item label="Notificações" icon="bell">
            <b-field>
              <b-checkbox type="is-primary" v-model="notificationSettings.email"
                >Notificações por email</b-checkbox
              >
            </b-field>
            <b-field
              label="Emails"
              label-position="on-border"
              type="is-primary"
              v-if="notificationSettings.email"
            >
              <b-taginput
                v-model="notificationSettings.email_list"
                type="is-primary"
                @add="wrapInObject"
                field="text"
                rounded
                icon="tag"
                placeholder="Tecle ENTER ao fim de cada email"
                :before-adding="beforeEmail"
              >
              </b-taginput>
            </b-field>
            <b-field>
              <b-checkbox type="is-primary" v-model="notificationSettings.sms"
                >Notificações por SMS</b-checkbox
              >
            </b-field>
            <b-field
              label="Contatos para SMS"
              label-position="on-border"
              type="is-primary"
              v-if="notificationSettings.sms"
            >
              <b-taginput
                v-model="notificationSettings.sms_list"
                type="is-primary"
                @add="wrapInObject"
                field="text"
                rounded
                icon="tag"
                placeholder="Tecle ENTER ao fim de cada contato de telefone"
                :before-adding="beforeSms"
              >
              </b-taginput>
            </b-field>

            <br />
            <b-field label="Intervalo entre notificações">
              <b-numberinput
                placeholder="Intervalo em minutos"
                step="15"
                min="15"
                max="1200"
                v-model="notificationSettings.interval_notification"
              >
              </b-numberinput>
            </b-field>
            <b-field>
              <b-button
                @click="saveNotificationSettings(notificationSettings)"
                :loading="saving"
                type="is-primary"
              >
                Salvar Configurações
              </b-button>
            </b-field>
          </b-tab-item>

          <b-tab-item label="Senhas" icon="lock">
            <div class="columns">
              <div class="column is-two-fifths is-16-mobile">
                <b-field>
                  <b-input
                    placeholder="Senha Antiga"
                    type="password"
                    password-reveal
                    v-model="oldPassword"
                    validation-message="Digite a senha antiga"
                    required
                  >
                  </b-input>
                </b-field>

                <b-field>
                  <div>
                    <b-input
                      type="password"
                      v-model="newPassword"
                      placeholder="Nova Senha"
                    />
                    <p id="warningPassword">{{ this.feedbackPassword }}</p>
                    <password
                      v-model="newPassword"
                      :strength-meter-only="true"
                      :SecureLength="10"
                      @score="showScore"
                    />
                  </div>
                </b-field>

                <b-field>
                  <div>
                    <b-input
                      placeholder="Confirmação da Nova Senha"
                      type="password"
                      password-reveal
                      v-model="confirmNewPassword"
                      validation-message="Precisa ser igual a Nova Senha"
                      required
                      :pattern="confirmNewPassword != newPassword"
                    />
                  </div>
                </b-field>

                <b-field>
                  <b-button
                    :disabled="
                      !oldPassword ||
                        !newPassword ||
                        confirmNewPassword !== newPassword ||
                        newPassword < 4
                    "
                    type="is-primary"
                    @click="savePassword"
                  >
                    Salvar Nova Senha
                  </b-button>
                </b-field>
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </section>
</template>
<script>
import store from "@/store";
import Webservices from "@/Webservices";
import { mapGetters, mapActions } from "vuex";
import Password from "vue-password-strength-meter";
const ws = new Webservices();

export default {
  components: {
    Password
  },
  data() {
    return {
      usuario: {
        photo: ""
      },
      oldPassword: undefined,
      newPassword: undefined,
      confirmNewPassword: undefined,
      formPhoto: true,
      formPassword: true,
      formTheme: true,
      notificationSettings: {
        controller_id: "",
        email: false,
        sms: false,
        email_list: [],
        sms_list: [],
        interval_notification: null,
        receive_ap_crowding: false,
        datetime: null,
        id: null
      },
      defaultNotifSett: {
        controller_id: "",
        email: false,
        sms: false,
        email_list: [],
        sms_list: [],
        interval_notification: null,
        receive_ap_crowding: false,
        datetime: null,
        id: null
      },
      saving: false,
      // alert: {
      //   show: false,
      //   type: "success",
      //   message: "Senha alterada com sucesso"
      // },
      imageName: "",
      imageUrl: "",
      imageFile: "",
      imageUploaded: false,
      isDark: true,
      fileObj: undefined,
      scorePassword: 0,
      feedbackPassword: ""
    };
  },
  async mounted() {
    if (await ws.checkAccessToken(this.getToken)) {
      this.logout();
      this.$router.push("/login");
    }
    this.usuario.photo = store.state.photo;
    ws.getNotificationConfigs(this.getControllerId).then(response => {
      this.notificationSettings = response.data[0];
      if (!this.notificationSettings)
        this.notificationSettings = this.defaultNotifSett;
    });
  },

  watch: {
    getControllerId(newValue) {
      this.client_fields = [];
      this.desserts = [];
      this.configs = [];

      ws.getNotificationConfigs(this.getControllerId).then(response => {
        this.notificationSettings = response.data[0];
        if (!this.notificationSettings)
          this.notificationSettings = this.defaultNotifSett;
      });
      // ws.getNotificationConfigs(this.getClientID).then(response => {
      //   this.desserts = response.data.map(el => ({
      //     ...el
      //   }));

      // });
    }
  },
  computed: {
    ...mapGetters(["getPhoto", "getUserId", "getClientID", "getControllerId"])
  },
  methods: {
    ...mapActions(["logout"]),
    savePhoto() {
      store.state.photo = this.usuario.photo;
      ws.saveSettings(this.getUserId, this.usuario.photo).then(res => {});
    },
    saveNotificationSettings(editedSettings) {
      this.saving = true;
      if (editedSettings.email && editedSettings.email_list.length == 0) {
        alert("Insira ao menos um email");
      } else if (editedSettings.sms && editedSettings.sms_list.length == 0) {
        alert("Insira ao menos um telefone");
      } else {
        ws.updateNotificationSettings(editedSettings).then(response => {
          alert("Configurações Atualizadas!");
        });
      }
      this.saving = false;
    },
    pickFile() {
      this.$refs.file.click();
    },
    onFilePicked(e) {
      if (e !== undefined) {
        this.imageName = e.name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        //Converting to base64
        const fr = new FileReader();
        fr.readAsDataURL(e);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = e; // this is an image file that can be sent to server...
        });
        fr.onload = () => {
          this.usuario.photo = fr.result;
          this.imageUploaded = true;
        };
      }

      /* const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        //Converting to base64
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
        fr.onload = () => {
          this.usuario.photo = fr.result;
          this.imageUploaded = true;
        };
      } */
    },
    savePassword() {
      ws.changePassword(this.oldPassword, this.newPassword)
        .then(response => {
          this.$buefy.snackbar.open({
            message: "Senha alterada com sucesso",
            type: "is-success",
            position: "is-top",
            actionText: "Fechar",
            indefinite: true
          });

          // this.alert = {
          //   show: true,
          //   type: "success",
          //   message: "Senha alterada com sucesso"
          // };
        })
        .catch(error => {
          console.log(error);
          this.$buefy.snackbar.open({
            message: "Não foi possível trocar a senha",
            type: "is-danger",
            position: "is-top",
            actionText: "Fechar",
            indefinite: true
          });
          // this.alert = {
          //   show: true,
          //   type: "error",
          //   message: "Não foi possível trocar a senha"
          // };
        });
    },
    wrapInObject() {
      var array = this.notificationSettings.answers;
      array.sort((a, b) => {
        var saida = 0;
        if (!a.hasOwnProperty("id")) saida = 1;
        else if (!b.hasOwnProperty("id")) saida = -1;
        else saida = a.id > b.id ? -1 : 1;

        return saida;
      });

      var lastElement = array[0];

      var newIndex = (lastElement.id || 0) + 1;
      var value = array[array.length - 1];
      array.splice(-1, 1, { id: newIndex, text: value });

      array.sort((a, b) => (a.id > b.id ? 1 : -1));
    },
    beforeEmail(tag) {
      var opa =
        new RegExp(/^\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi).test(tag) || false;
      // console.log("opa==>> ", opa)
      return opa;
    },
    beforeSms(tag) {
      var opa =
        new RegExp(/^[1-9]{2}(?:[2-8]|9[1-9])[0-9]{3}[0-9]{4}$/gm).test(tag) ||
        false;
      // console.log("opa==>> ", opa)
      return opa;
    },
    showScore(score) {
      this.scorePassword = score;

      if (score < 4) {
        this.feedbackPassword =
          "Senha fraca, tenta mesclar palavras e números ou usar caracteres";
      } else {
        this.feedbackPassword = "";
      }
    }
  }
};
</script>
<style>
.tab {
  margin-top: 20px;
}
.mini-photo {
  max-height: 180px !important;
}
#warningPassword {
  color: rgb(230, 111, 2);
  font-family: sans-serif;

  text-align: left;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue